import userApi from "./userApi";
import Swal from "sweetalert2";
const addProductView = (productId: number) => {
	let productViews = JSON.parse(<string>localStorage.getItem("productViews"));
	if (!productViews.includes(productId)) {
		productViews.push(productId);
		localStorage.setItem("productViews", JSON.stringify(productViews));
		fetch(`/ajax-api/product_view_plus.php`, {
			method: "post",
			body: JSON.stringify({ productId: productId }),
		})
			.then((res) => res.json())
			.then((res) => {
				console.log("res", res);
				userApi.addView(productId);
			});
	}
};
const getProductData = (productId: string) => {
	const id = parseInt(productId);
	const productNode = <HTMLElement>(
		document.querySelector(`.jsProduct[data-id="${id}"]`)
	);
	const orderdata = (<any>window).formToObject(productNode);
	let data: cartProductData = {
		services: {},
		productId: id,
	};
	Object.keys(orderdata).forEach((key) => {
		const value = orderdata[key];
		if (key.includes("service")) {
			let comment = "";
			if (key === "service_4") {
				comment = orderdata.comment_4;
			}
			if (key === "service_2") {
				comment = orderdata.comment_2;
			}
			(<any>data).services[value] = {
				id: parseInt(value),
				comment: comment,
			};
		}
	});
	return data;
};
export const checkEmail = async (email: string): Promise<boolean> => {
	console.log("checkEmail9", email);
	return new Promise((resolve, reject) => {
		const brokenEmails = (<any>window)?.brokenEmails || [];
		let includes = false;
		if (brokenEmails.length > 0) {
			for (let i = 0; i < brokenEmails.length; i++) {
				const x = brokenEmails[i];
				if (email.includes(x)) {
					includes = true;
					Swal.fire({
						icon: "warning",
						title: `Неправильно введена почта ${email.replace(
							x,
							'<span style="color:red">' + x + "</span>"
						)}`,
						// showDenyButton: false,
						// showCancelButton: true,
						// cancelButtonText: `ОК`,
						denyButtonColor: "#3085d6",
					}).then((result) => {
						resolve(false);
					});
				}
			}
			if (!includes) {
				resolve(true);
			}
		} else {
			resolve(true);
		}
	});
};
// export const checkComment = async (email: string): Promise<boolean> => {
// 	return new Promise((resolve, reject) => {
// 	});
// };

(<any>window).getProductData = getProductData;
export { addProductView, getProductData };
